import { RpcBaseData } from '../rpc-base';

/**
 * Electron request RPC call name and version.
 */
export class RpcElectronRequestKey {
    public static command = 'ElectronRequest';
    public static version = '0.1.0';
}

/**
 * Electron response RPC call name and version.
 */
export class RpcElectronResponseKey {
    public static command = 'ElectronResponse';
    public static version = '0.1.0';
}

/**
 * Electron operation/action RPC message.
 */
export interface RpcElectronOperation extends RpcBaseData {
    /**
     * Request specific Id to track completion.
     */
    eventName: string;

    /**
     * Request specific Id to track completion.
     */
    requestId: string;

    /**
     * The request payload to send to the electron host
     */
    payload: any;
}

/**
 * Electron operation/action RPC message result.
 */
export interface RpcElectronOperationResult {
    /**
     * Request specific Id to track completion.
     */
    requestId: string;

    /**
     * The response of the electron host operation
     */
    response?: any;

    /**
     * Error if any
     */
    error?: string;
}
